export const NAME_FORMAT_REGEX = /^[A-ZÅÄÖÁÉÍÓÚÝÑa-zåäöáéíóúýñ0-9\s-_.]*$/;
export const NAME_WITH_SPECIAL_CHARACTERS_FORMAT_REGEX = /^[A-ZÅÄÖÁÉÍÓÚÝÑa-zåäöáéíóúýñ0-9\s\-_.",()/€%&@+':;*#]*$/;
export const FIRST_NAME_MAX_LENGTH = 40;
export const LAST_NAME_MAX_LENGTH = 80;
export const FULL_NAME_MAX_LENGTH = 120;
